module.exports = __webpack_public_path__ + "thermo-c84896f6c6b213b687063a0b660fb085.png";